<template>
<!-- v-if="dataArray.length>0" -->
  <div class="overflow-x-auto scrollbar-hidden house-datatable" data-test="house-datatable">
    <Datatable :api-params="paramsComputed" :api-url="'house'" :method-request="'GET'" :init-sorter="[{field: 'UPDATE_DATETIME', dir: 'desc'}]" :data-array-table="dataArrayTable" :key="key" @rowClicked="handleRowClick" :downloadFile="downloadFile" :downloadExtraParams="downloadExtraParams" @getDataComplete="exportFile" question-group="household" stacked-mobile/>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from 'vue'
import Datatable from "@/components/datatable/index.vue"
import {useStore} from "vuex"
import { useRouter } from 'vue-router'
import { utils, writeFileXLSX, writeFile } from "xlsx"
import { utils as xlsxStyleUtils, writeFile as writeFileStyled } from "xlsx-js-style"
import Swal from 'sweetalert2'
import exportFields from "@/data/exportFields.json"
import { getPermissionAccessMenu } from "@/utils/getPermission"
import householdRules from "@/utils/household_rules.json"
import { findSimilarSurnames } from "@/utils/checkHouseholdSurvey.js"

const props = defineProps({
  filter:{
    type: Object
  },
  downloadCsv:{
    type: String
  },
  downloadExcel: {
    type: String
  },
  downloadErrorReport: {
    type: Boolean
  }
})
const emits = defineEmits(["downloadCsvComplete", "downloadExcelComplete", "downloadErrorReportComplete"])
let dataArray = ref([])
const store = useStore()
const filterValue = ref()
const params = ref({start: 1,draw: 10,length: 10})
const key = ref(1)
const router = useRouter()
const downloadFile = ref(false)
const currentFileType = ref("")
const downloadFormat = ref(null)
watch(()=>props.filter, ()=>{
  key.value++
})
// watch(()=>props.reloadTable,(val)=>{
//      key.value++
// })
const onlineComputed = computed(()=>store.getters["network/isOnline"])
const paramsComputed = computed(() => ({...params.value, ...props.filter}))
const downloadExtraParams = computed(() => currentFileType.value === "error_report" ? { is_verified: false } : {})
var datediffMutator = (value, data, type, params, component) => {
  return {"datediff": data.datediff, "head_img": "@/assets/images/main/logo_logbook.png"}
}
var customNameMutator = (value, data, type, params, component) => {
  return `${data.prefix_name ? data.prefix_name : "ไม่มีหัวหน้าครัวเรือน"}${data.name ? data.name : ""} ${data.surname ? data.surname : ""}`
}
var customAddressMutator = (value, data, type, params, component) => {
  return `${data.address_num ? data.address_num:""} ${data.moo?'หมู่ '+data.moo:""} ${data.village_name?data.village_name: ""} ${data.tambol_name?'ตำบล'+data.tambol_name: ""}  ${data.amphur_name?'อำเภอ'+data.amphur_name: ""}`
}
var customProblemMutator = (value, data, type, params, component) => {
  return {
    "health": false,
    "housing": false,
    "education": false,
    "occupation": false,
    "accessibility": false
  }
}
const dataArrayTable = reactive([
  // {title:"", field:"tb_pic", resizable:true, mutator: datediffMutator,
  // formatter:function(cell, formatterParams){
  //     var value = cell.getValue();
  //     let res = `<div class="flex flex-wrap">\
  //     <img src="${value.head_img}">\
  //     <input type="hidden" value="${value.datediff}">\
  //     </div>
  //     `
  //     return res
  //     }
  // },
  {title:"สถานะตรวจสอบ", field:"is_verified", hozAlign:"center", resizable:true, width: 155, formatter:"textarea", formatter:function(cell, formatterParams){
    return cell.getValue() ? 
      `<span class="flex items-center md:bg-theme-47 text-theme-46 md:text-xs font-medium px-2 py-0.5 rounded-full">
        <span class="h-1.5 w-1.5 bg-theme-46 rounded-full mr-1"></span>
        ผ่าน
      </span>`
      : 
      `<span class="flex items-center md:bg-theme-49 text-theme-48 md:text-xs font-medium px-2 py-0.5 rounded-full">
        <span class="h-1.5 w-1.5 bg-theme-48 rounded-full mr-1"></span>
        ไม่ผ่าน
      </span>`
  }},
  {title:"หัวหน้าครัวเรือน", field:"full_name", resizable:true, formatter:"textarea", minWidth: 250,formatter:function(cell, formatterParams){
    return cell.getValue() ? cell.getValue() : 'ไม่มีหัวหน้าครัวเรือน'
  }},
  {title:"ที่อยู่", field:"full_address", hozAlign:"left", formatter:"textarea", resizable:true, minWidth: 300,},
  {title:"ปัญหา 5 มิติ", field:"poverty_dimensions", hozAlign:"center", minWidth: 250, variableHeight:true, resizable:true,
    formatter:function(cell, formatterParams){
      const value = cell.getValue() || {
          living: false,
          health: false,
          income: false,
          education: false,
          accessibility: false
      };
      let temp = ""
      for(const [key, val] of Object.entries(value)){
          let icon = "", text = ""
          if(key === "living"){
              icon = "home-icon"
              text = "ครอบครัว"
          }
          if(key === "health"){
              icon = "heart-icon"
              text = "สุขภาพอนามัย"
          }
          if(key === "income"){
              icon = "dollar-sign-icon"
              text = "การมีงานทำและมีรายได้"
          }
          if(key === "education"){
              icon = "book-open-icon"
              text = "การศึกษา"
          }
          if(key === "accessibility"){
              icon = "card-icon"
              text = "การเข้าไม่ถึงสิทธิและความเป็นธรรมในสังคม"
          }
          temp+= `<button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-1 mb-1 text-white ${val ? 'bg-theme-1 hover:bg-theme-1':'bg-theme-37 hover:bg-theme-37'}'>\
                      <span class="t-tooltip-text">${text}</span>\
                      <span class="img-icon ${icon}"></span>\
                  </button>`
      }
      let res = `<div class="flex flex-wrap justify-start lg:justify-center">${temp}</div>`
      return res
    }
  },
  {title:"จำนวนสมาชิกในครัวเรือน", field:"member_cnt", hozAlign:"center", resizable:true, minWidth: 195, width: 220, formatter:"textarea", formatter:function(cell, formatterParams){
    return cell.getValue() ? cell.getValue() : 0
  }},
  {title:"จำนวนสมาชิกตามทะเบียนบ้าน", field:"member_reg_cnt", hozAlign:"center", resizable:true, minWidth: 220, width: 240, formatter:"textarea", formatter:function(cell, formatterParams){
    return cell.getValue() ? cell.getValue() : 0
  }},
  // {title:"จำนวนครั้งที่สำรวจ", field:"house_surveys_count", hozAlign:"center", resizable:true, minWidth: 175, width: 200, formatter:"textarea",}, 
  {title:"วันที่ปรับปรุงข้อมูลล่าสุด", field:"UPDATE_DATETIME", hozAlign:"center", minWidth: 200, width: 220, variableHeight:true,
    formatter:function(cell, formatterParams){
      if(cell.getValue()){
        let date = cell.getValue().split`T`[0]
        date = new Date(date)
        return [String(date.getDate()).padStart(2, '0'),
                  String(date.getMonth() + 1).padStart(2, '0'),
                  date.getFullYear() + 543
                ].join('/');
      }
      return null
    }
  },
  {title:"สถานะ", field:"house_surveys_status", hozAlign:"center", resizable:true, minWidth: 130, width: 150, formatter:"textarea", formatter:function(cell, formatterParams){
    return cell.getValue() == "DRAFT" ? "ร่าง" : cell.getValue() == "COMPLETE" ? "สำเร็จ" : null
  }},
  {title:"พิกัด", field:"latitude", hozAlign:"center", resizable:true, minWidth: 80, width: 100,
    formatter:function(cell, formatterParams){
      const value = cell.getValue();
      const iconAddr = `<span class="coordinate-icon m-auto w-8 h-8 p-2 flex justify-center items-center ${value?'bg-theme-17':'bg-theme-37'} dark:bg-theme-26 text-white rounded-full"><span class="img-icon map-pin-icon"></span>\</span>`
      return iconAddr
    }
  },
])
const handleRowClick = (row) =>{
  if(getPermissionAccessMenu("read") || !onlineComputed.value){
    router.push({
      name: "household-profile",
      params: {
        hhid: row._id,
        surveyid: row.house_surveys_id
      },
    })
  }
}


watch(()=> props.downloadCsv, (val)=>{
  if(val){
    downloadFile.value = true//props.downloadCsv
    currentFileType.value = "csv"
    downloadFormat.value = val
  }
})

watch(()=> props.downloadExcel, (val)=>{
  if(val){
    downloadFile.value = props.downloadExcel
    currentFileType.value = "xlsx"
    downloadFormat.value = val
  }
})

watch(()=> props.downloadErrorReport, (val)=>{
  if(val){
    downloadFile.value = true
    currentFileType.value = "error_report"
  }
})

const getMessages = (validation) => {
  if(!validation || !Array.isArray(validation.errors)) return []
  return validation.errors.map((err) => `- ${err.message}`)
}

const getMemberFullName = (member) => {
  const name = `${member.prefix_name ?? ""}${member.name ?? ""} ${member.surname ?? ""}`.trim()
  return name || member.member_id
}

const getRecorderName = (source) => {
  if(!source) return ""
  return [source.survey_name_first, source.survey_name_second, source.survey_name_third]
    .filter((name) => name)
    .join(", ")
}
const getRecorderPhone = (source) => source?.survey_phonenumber || ""
const similarSurnameRule = householdRules.find((rule) => rule.ruleId === "SIMILAR_SURNAME_CHECK")
const getSimilarSurnameMessages = (members) => {
  if(!similarSurnameRule || !members.length) return []
  const key = similarSurnameRule.validation?.left?.key || "surname"
  const maxDiff = similarSurnameRule.validation?.left?.maxDiff ?? 3
  const groups = findSimilarSurnames(members, key, maxDiff)
  return groups.length ? [similarSurnameRule.errorMessage] : []
}

const buildErrorReportRows = (houseList) => {
  const rows = []
  const rowGroup = []
  const rowBold = []
  let houseIndex = 0
  for(const item of houseList){
    const members = Array.isArray(item.house_surveys?.member_surveys) ? item.house_surveys.member_surveys : []
    const houseMessages = [...getMessages(item.validate_survay), ...getSimilarSurnameMessages(members)]
    const memberBlocks = members
      .map((member) => ({
        member,
        member_name: getMemberFullName(member),
        sections: [
          ["ผลการตรวจสอบสมาชิก", getMessages(member.validate_survay), member],
          ["ผลการตรวจสอบเด็กพิการ (CWD)", getMessages(member.validate_survey_cwd), member.validate_survey_cwd],
          ["ผลการตรวจสอบ NEET", getMessages(member.validate_survey_neet), member.validate_survey_neet],
        ].filter(([, messages]) => messages.length),
      }))
      .filter((block) => block.sections.length)

    if(!houseMessages.length && !memberBlocks.length) continue

    const pushRow = (resultValue, { bold = false, address = "", recorderName = "", recorderPhone = "" } = {}) => {
      rows.push([address, resultValue, recorderName, recorderPhone])
      rowGroup.push(houseIndex)
      rowBold.push(bold)
    }

    pushRow("", { address: item.full_address })

    if(houseMessages.length){
      pushRow("ผลการตรวจสอบครัวเรือน", {
        bold: true,
        recorderName: getRecorderName(item.house_surveys),
        recorderPhone: getRecorderPhone(item.house_surveys),
      })
      for(const message of houseMessages){
        pushRow(message)
      }
    }

    for(const block of memberBlocks){
      pushRow("ชื่อสมาชิก", { bold: true })
      pushRow(block.member_name)
      for(const [label, messages, recorderSource] of block.sections){
        pushRow(label, {
          bold: true,
          recorderName: getRecorderName(recorderSource),
          recorderPhone: getRecorderPhone(recorderSource),
        })
        for(const message of messages){
          pushRow(message)
        }
      }
    }

    pushRow("") // เว้น row ว่างคั่นระหว่างครัวเรือน
    houseIndex++
  }
  return { rows, rowGroup, rowBold }
}

const ERROR_REPORT_HEADERS = ["ที่อยู่ครัวเรือน", "ผลการตรวจสอบ", "ชื่อผู้บันทึก", "เบอร์โทรศัพท์ผู้บันทึก"]
const ROW_COLOR_EVEN = "FFF2F2F2"
const ROW_COLOR_ODD = "FFFFFFFF"
const applyErrorReportRowColors = (ws, rowGroup, rowBold) => {
  rowGroup.forEach((groupIndex, i) => {
    const bg = groupIndex % 2 === 0 ? ROW_COLOR_EVEN : ROW_COLOR_ODD
    for(const c of [0, 1, 2, 3]){
      const ref = xlsxStyleUtils.encode_cell({ r: i + 1, c })
      if(!ws[ref]) ws[ref] = { t: "s", v: "" }
      ws[ref].s = {
        fill: { patternType: "solid", fgColor: { rgb: bg } },
        ...(rowBold[i] ? { font: { bold: true } } : {}),
      }
    }
  })
  for(const c of [0, 1, 2, 3]){
    const ref = xlsxStyleUtils.encode_cell({ r: 0, c })
    if(!ws[ref]) ws[ref] = { t: "s", v: "" }
    ws[ref].s = { font: { bold: true } }
  }
}
const exportFile = (evt, questions) => {
  if(evt.status === 200){
    if(currentFileType.value === "error_report"){
      const { rows, rowGroup, rowBold } = buildErrorReportRows(evt.data || [])
      const ws = xlsxStyleUtils.aoa_to_sheet([ERROR_REPORT_HEADERS, ...rows])
      applyErrorReportRowColors(ws, rowGroup, rowBold)
      const wb = xlsxStyleUtils.book_new();
      xlsxStyleUtils.book_append_sheet(wb, ws, "Sheet1");
      let date = new Date()
      let current_date = [date.getFullYear(),String(date.getMonth() + 1).padStart(2, '0'),String(date.getDate()).padStart(2, '0'),String(date.getHours()).padStart(2, '0'),String(date.getMinutes()).padStart(2, '0'),String(date.getSeconds()).padStart(2, '0')].join('')
      let file_name = `${props.filter?.village_ID ? props.filter.village_ID : props.filter?.tambol_ID ? props.filter.tambol_ID : props.filter?.amphur_ID ? props.filter.amphur_ID : props.filter?.province_ID ? props.filter.province_ID : "" }_ครัวเรือน_ผลการตรวจสอบ_${current_date}`
      writeFileStyled(wb, `${file_name}.xlsx`);
      downloadFile.value = false
      emits("downloadErrorReportComplete")
      return
    }
    let columns_header = {
      toExport: ["HH001"],
      toCompare: []
    }
      
    const getExportCodesForQuestion = (q) => {
        if(q.question_code == "address_num")
          return ["HH002"]
        if(q.question_code == "subDistrictSelected")
          return ["HH003"]
        if(q.question_code == "districtSelected")
          return ["HH004"]
        if(q.question_code == "provinceSelected")
          return ["HH005"]
        if(q.question_code == "postcode")
          return ["HH006"]
        if(q.question_code == "sector")
          return ["HH007"]
        if(q.question_code == "township")
          return ["HH008"]
        if(q.question_code == "informant_prefix_name")
          return ["HH009"]
        if(q.question_code == "position")
          return ["HH010", "HH010-1"]//["HH010", "HH010-1"]
        if(q.question_code == "member_cnt")
          return ["HH011"]
        if(q.question_code == "member_reg_cnt")
          return ["HH012"]
        if(q.question_code == "house_number_11")
          return ["HH013"]
        if(q.question_type == "checkbox"){
          if(q.is_checkbox_group){
            const res = q.choices.map(c => {
              if(c?.specify_value?.length > 1){
                let tempCh = []
                let current_code = q.is_new_survey ? c.option.code : parseInt(c.option.code.replace(/[^\d]/g, ""))
                let current_text_code = c.option.code.replace(/[\d]/g, "")
                for(let i = 1 ; i <= c.specify_value.length; i++){
                  if(q.is_new_survey){
                    tempCh.push(`${c.option.code}-${i}`)
                  }
                  else{
                    tempCh.push(`${current_text_code}${String(current_code).padStart(3, '0')}`)
                    current_code++
                  }
                }
                return tempCh
              }
              return c.option.code
            }).flat()
            columns_header.toCompare.push(q.question_code)
            return res
          }
          else if(q.choices.some(c => c.option.hasOwnProperty("order"))){
            let haveSpecify = q.choices.find(c => c.specify_value)

            let temp = []
            for(let i = 1; i<=q.answer_limit; i++){
              temp.push(`${q.question_code}-${i}`)
              if(haveSpecify){
                for(let j = 1 ; j <= haveSpecify.specify_value.length; j++){
                  temp.push(`${q.question_code}-${i}-${j}`)
                }
              }
            }
            return temp
          }
          else{
            if(q.choices.length){
              let haveSpecify = q.choices.find(c => c.specify_value)
              let temp = []
              for(let i = 1; i <= q.choices.length; i++){
                temp.push(`${q.question_code}-${i}`)
                if(haveSpecify){
                  for(let j = 1 ; j <= haveSpecify.specify_value.length; j++){
                    temp.push(`${q.question_code}-${i}-${j}`)
                  }
                }
              }
              return temp
            }
          }
        }
        if(q.question_type == "multiple-inputs-answer"){
          if(q.choices.length > 1){
            let tempCh = []
            let current_code = q.is_new_survey ? q.question_code : parseInt(q.question_code.replace(/[^\d]/g, ""))
            let current_text_code = q.question_code.replace(/[\d]/g, "")
            for(let i = 1 ; i <= q.choices.length; i++){
              if(q.is_new_survey){
                tempCh.push(`${current_code}-${i}`)
              }
              else{
                tempCh.push(`${current_text_code}${String(current_code).padStart(3, '0')}`)
                current_code++
              }
            }
            return tempCh
          }
          return [q.question_code]
        }
        if((q.question_type == "radio") && q.choices.some(c => c.specify_value) && q.question_code != "position"){
          let specify = q.choices.find(c=>c.specify_value)
          let tempCode = []
          if(specify){
            for(let i = 1 ; i <= specify.specify_value.length; i++){
              tempCode.push(`${q.question_code}-${i}`)
            }
          }
          return [q.question_code,...tempCode]
        }

        return [q.question_code]
    }

    const questionExportCodes = questions.map((q) => ({ q, codes: getExportCodesForQuestion(q) }))
    columns_header.toExport = [...columns_header.toExport, ...questionExportCodes.map(({ codes }) => codes).flat()]
    columns_header.toExport = columns_header.toExport.sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true })
    )
    columns_header.toExport.unshift("verified_status", "province_name", "amphur_name", "tambol_name", "village_name")
    columns_header.toExport.push("survey_status", "survey_start_date", "survey_end_date", "survey_start_time", "survey_end_time", "house_id")

    const EXCLUDED_QUESTION_DICTIONARY_CODES = ["soi", "road", "villageSelected", "informant_name", "informant_surname", "survey_date"]
    const MANUAL_QUESTION_DICTIONARY_LABELS = { HH001: "รหัสประจำบ้าน", HH009: "ชื่อผู้ให้ข้อมูล" }
    const getDictionaryLabel = (q, code) => {
      if(q.question_type == "checkbox" && q.is_checkbox_group){
        const choice = q.choices.find((c) => code === c.option.code || code.startsWith(`${c.option.code}-`))
        if(choice) return `${q.question_desc} (${choice.option.desc})`
      }
      if(q.question_type == "radio" && q.choices.some((c) => c.specify_value) && q.question_code != "position"){
        if(code != q.question_code && code.startsWith(`${q.question_code}-`)) return `${q.question_desc} (กรณีตอบอื่นๆ)`
      }
      return q.question_desc
    }
    const questionDictionaryRows = [
      { "รหัสคำถาม": "HH001", "ชื่อคำถาม": MANUAL_QUESTION_DICTIONARY_LABELS.HH001 },
      { "รหัสคำถาม": "HH009", "ชื่อคำถาม": MANUAL_QUESTION_DICTIONARY_LABELS.HH009 },
      ...questionExportCodes.flatMap(({ q, codes }) =>
        codes
          .filter((code) => !EXCLUDED_QUESTION_DICTIONARY_CODES.includes(code) && !MANUAL_QUESTION_DICTIONARY_LABELS[code])
          .map((code) => ({ "รหัสคำถาม": code, "ชื่อคำถาม": getDictionaryLabel(q, code) }))
      ),
    ].sort((a, b) => a["รหัสคำถาม"].localeCompare(b["รหัสคำถาม"], undefined, { numeric: true }))

    let newArr = evt.data.map((item)=>{
      let newItem = {}
        for(let col of columns_header.toExport){
          if(item[col])
            newItem[col] = item[col]
          else
            newItem[col] = null
        }
        //sort column
        if(item.house_number_ID){
          newItem["HH001"] = String(item.house_number_ID)
        }
        // if(item.address_num || item.soi || item.road || item.village_name){
        //   item["HH002"] = `${item.address_num ?? ""} ${item.village_name ?? ""} ${item.soi ? 'ซอย'+item.soi : ""} ${item.road ? 'ถนน'+item.road : ""}`
        // }
        if(item.tambol_name){
          newItem["HH003"] = item.tambol_name
        }
        if(item.amphur_name){
          newItem["HH004"] = item.amphur_name
        }
        if(item.province_name){
          newItem["HH005"] = item.province_name
        }
        if(item.postcode){
          newItem["HH006"] = item.postcode
        }
        if(item.sector){
          newItem["HH007"] = item.sector
        }
        if(item.township){
          newItem["HH008"] = item.township.desc
        }
        // if(item.HH009){
        //   newItem["HH009"] = item.HH009
        // }
        if(item.house_number_11){
          newItem["HH013"] = item.house_number_11
        }
        if(item.validate_survay){
          newItem["verified_status"] = item.validate_survay.is_verified ? "ผ่าน" : "ไม่ผ่าน"
        }

        if(item.house_surveys){
          const keys = Object.keys(item.house_surveys)
          // if(item.house_surveys.informant_prefix_name || item.house_surveys.informant_name || item.house_surveys.informant_surname){
          //   newItem["HH009"] = `${item.house_surveys.informant_prefix_name ?? ""} ${item.house_surveys.informant_name ?? ""} ${item.house_surveys.informant_surname ?? ""}`
          // }
          if(item.house_surveys.position){
            if(downloadFormat.value == "desc"){
              newItem["HH010"] = item.house_surveys.position.desc
            }
            else{
              newItem["HH010"] = item.house_surveys.position.code.split("-")?.[1] ? item.house_surveys.position.code.split("-")[1] : item.house_surveys.position.code.split("-")[0]
            }
            if(item.house_surveys.position?.other)
              newItem["HH010-1"] = item.house_surveys.position.other
          }
          if(item.house_surveys.member_cnt || item.house_surveys.member_cnt == 0){
            newItem["HH011"] = item.house_surveys.member_cnt
          }
          if(item.house_surveys.member_reg_cnt || item.house_surveys.member_reg_cnt == 0){
            newItem["HH012"] = item.house_surveys.member_reg_cnt
          }
          if(item.house_surveys.status)
            newItem["survey_status"] = item.house_surveys.status
          if(item.house_surveys.survey_start_date)
            newItem["survey_start_date"] = item.house_surveys.survey_start_date
          if(item.house_surveys.survey_end_date)
            newItem["survey_end_date"] = item.house_surveys.survey_end_date


          keys.forEach((elm)=>{
            if((item.house_surveys[elm] || item.house_surveys[elm] == 0) && Object.values(columns_header).flat().some(col => col.includes(elm))){
              if(typeof item.house_surveys[elm] === "object"){
                let tempObj = questions.find(({question_code}) => elm === question_code)
                if(Array.isArray(item.house_surveys[elm]) && tempObj){
                  if(questions.some(q=>q.question_code == elm && q.is_checkbox_group)){
                    let temp = []
                    item.house_surveys[elm].forEach((it)=>{
                      const choice = tempObj.choices.find(x => x.option.code === it.code)
                      if(choice?.is_multiple_answer){
                        if(choice?.specify_value && it?.answers){
                          let current_question_code = tempObj.is_new_survey ? choice.option.code : parseInt(choice.option.code.replace(/[^\d]/g, ""))
                          const current_question_text_code = choice.option.code.replace(/[\d]/g, "")
                          let i = 0
                          for(let ch of choice.specify_value){
                            i++
                            let codeNum = null
                            if(choice.specify_value.length == 1){
                              codeNum = choice.option.code
                            }
                            else{
                              if(tempObj.is_new_survey){
                                codeNum = `${choice.option.code}-${i}`
                              }
                              else{
                                codeNum = `${current_question_text_code}${String(current_question_code).padStart(3, '0')}`
                                current_question_code++
                              }
                            }
                            let valueArr = []
                            for(let val of it.answers){
                              if(val[ch.key] || val[ch.key] == 0){
                                valueArr.push(val[ch.key])
                              }
                            }
                            temp.push({code: codeNum, value: valueArr.join(", ")})
                          }
                        }
                      }
                      else{
                        if(choice?.specify_value){
                          let current_question_code = tempObj.is_new_survey ? choice.option.code : parseInt(choice.option.code.replace(/[^\d]/g, ""))
                          const current_question_text_code = choice.option.code.replace(/[\d]/g, "")
                          let i = 0
                          
                          for(let ch of choice.specify_value){
                            i++
                            let codeNum = null
                            if(choice.specify_value.length == 1){
                                codeNum = choice.option.code
                            }
                            else{
                              if(tempObj.is_new_survey){
                                codeNum = `${choice.option.code}-${i}`
                              }
                              else{
                                codeNum = `${current_question_text_code}${String(current_question_code).padStart(3, '0')}`
                                current_question_code++
                              }
                            }
                            if(it[ch.key] || it[ch.key] == 0){
                                temp.push({code: codeNum, value: it[ch.key]})
                            }
                          }
                        }
                      }

                    })
                    const newData = temp.reduce((a,v)=> ({...a, [v.code]: v.value}),{})
                    return newItem = {...newItem, ...newData}
                  }
                  else{
                    const res = item.house_surveys[elm].reduce((temp,v, idx)=> {
                      const choice = tempObj.choices.find(x => x.option.code === v.code)
                      let tempDesc = ""
                      let tempAnswerObj = {}
                      if(downloadFormat.value == "desc"){
                        tempDesc = choice ? choice.option.desc : v.desc
                      }
                      else{
                        tempDesc = choice ? choice.option.code.split('-')[1] : v.code.split('-')[1]
                      }
                      tempAnswerObj = {...tempAnswerObj, [`${elm}-${idx+1}`]: tempDesc}
                      if(choice?.is_multiple_answer){
                        if(choice?.specify_value && v?.answers){
                          let i = 0
                          for(let ch of choice.specify_value){
                            i++
                            let valueArr = []
                            for(let val of v.answers){
                              if(val[ch.key] || val[ch.key] == 0){
                                valueArr.push(val[ch.key])
                              }
                            }
                            tempAnswerObj = {...tempAnswerObj, [`${elm}-${idx+1}-${i}`]: valueArr.join(", ")}
                          }
                        }
                      }
                      else{
                        if(choice?.specify_value){
                          let i = 0
                          for(let ch of choice.specify_value){
                            i++
                            if(v[ch.key] || v[ch.key] == 0){
                              tempAnswerObj = {...tempAnswerObj, [`${elm}-${idx+1}-${i}`]: v[ch.key]}
                            }
                          }
                        }
                      }
                      return {...temp, ...tempAnswerObj}
                    },{})
                    return newItem = {...newItem,...res}
                  }
                }
                else{
                  if(item.house_surveys[elm]?.desc && tempObj && tempObj?.question_code != "position"){
                    const choice = tempObj.choices.find(x => x.option.code === item.house_surveys[elm].code)
                    let tempAnswerObj = {}
                    let tempDesc = ""
                    if(downloadFormat.value == "desc"){
                      tempDesc = choice ? choice.option.desc : item.house_surveys[elm].desc
                    }
                    else{
                      tempDesc = choice ? choice.option.code.split('-')?.[1] ? choice.option.code.split('-')[1] : choice.option.code.split('-')[0]  : item.house_surveys[elm].code.split('-')?.[1] ? item.house_surveys[elm].code.split('-')[1] : item.house_surveys[elm].code.split('-')[0]
                    }
                    tempAnswerObj = {...tempAnswerObj, [elm]: tempDesc}
                    if(choice?.is_multiple_answer){
                      if(choice?.specify_value && item.house_surveys[elm]?.answers){
                        let i = 0
                        for(let ch of choice.specify_value){
                          i++
                          let valueArr = []
                          for(let val of item.house_surveys[elm].answers){
                              if(val[ch.key] || val[ch.key] == 0){
                                  valueArr.push(val[ch.key])
                              }
                          }
                          tempAnswerObj = {...tempAnswerObj, [`${elm}-${i}`]: valueArr.join(", ")}
                        }
                      }
                    }
                    else{
                      if(choice?.specify_value){
                        let i = 0
                        for(let ch of choice.specify_value){
                          i++
                          if(item.house_surveys[elm][ch.key] || item.house_surveys[elm][ch.key] == 0){
                            tempAnswerObj = {...tempAnswerObj, [`${elm}-${i}`]: item.house_surveys[elm][ch.key]}
                          }
                        }
                      }
                    }
                    return newItem = {...newItem, ...tempAnswerObj}
                  }
                  else if(tempObj?.question_type == "multiple-inputs-answer"){//object answer has no desc only this type
                    const choice = tempObj.choices
                    let current_question_code = tempObj.is_new_survey ? tempObj.question_code : parseInt(tempObj.question_code.replace(/[^\d]/g, ""))
                    const current_question_text_code = tempObj.question_code.replace(/[\d]/g, "")
                    let i = 0
                    let tempInp = {}
                    for(let ch of choice){
                      i++
                      let codeNum = null
                      if(choice.length == 1){
                        codeNum = current_question_code
                      }
                      else{
                        if(tempObj.is_new_survey){
                          codeNum = `${current_question_code}-${i}`
                        }
                        else{
                          codeNum = `${current_question_text_code}${String(current_question_code).padStart(3, '0')}`
                          current_question_code++
                        }
                      }
                      if(item.house_surveys[elm][ch.key] || item.house_surveys[elm][ch.key] == 0){
                        tempInp = {...tempInp, [codeNum]: item.house_surveys[elm][ch.key]}
                      }
                    }
                    return newItem = {...newItem, ...tempInp}
                  }
                }
              }
              return newItem[elm] = item.house_surveys[elm]
            }
          })
        }
      
      return newItem
    })

    newArr = newArr.map(({ amphur_ID, position, CREATE_DATETIME, UPDATE_DATETIME, image, moo,province_ID, road, sector, soi, status, tambol_ID, village_ID, house_surveys_count, member_cnt, member_reg_cnt, informant_name, informant_surname, full_address, full_name, headOfHouseholdPrefixName, headOfHouseholdName, headOfHouseholdSurname, survey_user, create_by, update_by, house_number_ID, member_surveys, headOfHousehole_name, headOfHousehole_prefix_name, headOfHousehole_surname, survey_date, villageSelected, step, _id, ...rest}) => ({...rest}));
    const ws = utils.json_to_sheet(newArr)
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");
    if(currentFileType.value == "xlsx"){
      const questionDictionaryWs = utils.json_to_sheet(questionDictionaryRows)
      utils.book_append_sheet(wb, questionDictionaryWs, "รหัสคำถาม")
    }
    let date = new Date()
    let current_date = [date.getFullYear(),String(date.getMonth() + 1).padStart(2, '0'),String(date.getDate()).padStart(2, '0'),String(date.getHours()).padStart(2, '0'),String(date.getMinutes()).padStart(2, '0'),String(date.getSeconds()).padStart(2, '0')].join('')
    let file_name = `${props.filter?.village_ID ? props.filter.village_ID : props.filter?.tambol_ID ? props.filter.tambol_ID : props.filter?.amphur_ID ? props.filter.amphur_ID : props.filter?.province_ID ? props.filter.province_ID : "" }_ครัวเรือน_${downloadFormat.value == "code" ? 'รหัส' : 'คำอธิบาย'}_${current_date}`
    //for csv
    if(currentFileType.value == "csv"){
      writeFile(wb, `${file_name}.csv`);
    }
    //for excel
    if(currentFileType.value == "xlsx"){
      writeFile(wb, `${file_name}.xlsx`);
    }
  }else{
    Swal.fire({
      icon: "warning",
      text: "ระบบผิดพลาด",
    })
  }
  downloadFile.value = false
  emits("downloadCsvComplete")
  emits("downloadExcelComplete")
}
</script>
<style lang="scss">
</style>

